export const isHomeApiEnabled = (storeId: number | null, teamId: number | null, aggregation: string) => {
  return !!storeId && ((!!teamId && aggregation === 'TEAM') || aggregation === 'STORE')
}
